
import React from 'react';

import {
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button,
    Container,
    Row,
    Col
} from 'reactstrap';

import RGL, { WidthProvider } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'

import Isvg from 'react-inlinesvg';
import moveIcon from '../../assets/svg/move.svg';
import moreIcon from '../../assets/svg/more.svg';

import moment from 'moment';
import DateNavigation from './dateNavigation';
import CalendarEventComponent from './calendarEventComponent';
import CustomCalendar from './customCalendar';
import CustomFilterCalendar from './customFilterCalendar';
import Page from '../../containers/page';
import { API_ENDPOINT } from '../../constants';
import { Player, Controls } from "@lottiefiles/react-lottie-player";
import { v4 as uuidv4 } from 'uuid';
import UpdateEventModal from './updateEventModal';
import ErrorModal from '../../components/errorModal';
import ScheduleEventModal from './scheduleEventModal';
import ScheduleSlot from './scheduleEventHelper/scheduleSlot';
import OccupancyCalendar from './occupancyCalendar';


function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}


class Occupancy extends React.Component {

    constructor(props) {
        super(props);
        this.wrapperRef = React.createRef();

        this.state = {
            filter: {
                clinicians: [],
                professions: [],
                eventTypes: []
            },
            events: [],
            legendData: [],
            updatedEvents: []

        }
    }

    setInitialData = () => {
        this.prepareLegendData();
    }
    prepareLegendData = () => {
        let legendData = [
            { name: 'Booked'.translate(this.props.lang), color: '#E05555', viewMode: 'duration' },
            { name: 'Available'.translate(this.props.lang), color: '#3FB3AD', viewMode: 'duration' },
            { name: 'Total'.translate(this.props.lang), color: '#E6951F', viewMode: 'duration' },
            { name: 'Number of events'.translate(this.props.lang), color: '#3FB3AD', viewMode: 'counts' },

        ];


        this.setState({ legendData });
    }




    componentDidMount() {
        this.setInitialData();


    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedGroup !== this.props.selectedGroup || prevProps.selectedClinic !== this.props.selectedClinic) {
            this.resetPage();
        }

    }
    resetPage = () => {
        const pathname = this.props[0].location.pathname;
        const refreshPathname = '/refresh/page';
        const stateObj = {
            reditectTo: pathname
        }
        if (pathname) {
            this.props[0].history.push(refreshPathname, stateObj);
        }
    }
    componentWillUnmount() {


    }

    fetchItems = () => {
        const filter = this.state.filter;
        if (!filter) return;

        const clinicians = filter?.clinicians ?? [];
        const professions = filter?.professions ?? [];
        const eventTypes = filter?.eventTypes ?? [];

        const calendarConfig = this.state.calendarConfig;
        if (!calendarConfig?.date || !calendarConfig?.view || !calendarConfig?.viewMode) return;

        if (clinicians.length === 0) {
            this.setState({ availabilityData: null, summary: null })
            return;
        }
        let data = {
            clinicians,
            professions,
            eventTypes,
            calendarConfig,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
        }
        // console.log('data', data)

        this.setState({ loading: true, availabilityData: null, summary: null }, () => {
            let fetchKey = uuidv4();
            this.fetchKey = fetchKey;
            data.fetchKey = fetchKey;
            fetch(API_ENDPOINT + `/data/calendar/occupancy/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.availabilityData && this.fetchKey === result?.fetchKey) {
                    this.setState({ availabilityData: result.availabilityData, summary: result?.summary, loading: false })
                } else {
                    this.setState({ loading: false })
                }
            }).catch(err => {
                console.log(err);
                this.setState({ loading: false })
            })
        })

    }
    exportData = (type) => {
        const filter = this.state.filter;
        if (!type || !this.state.availabilityData || !filter) return;

        const clinicians = filter?.clinicians ?? [];
        const professions = filter?.professions ?? [];
        const eventTypes = filter?.eventTypes ?? [];

        const calendarConfig = this.state.calendarConfig;
        if (!calendarConfig?.date || !calendarConfig?.view || !calendarConfig?.viewMode) return;

        if (clinicians.length === 0) {
            this.setState({ availabilityData: null, summary: null })
            return;
        }

        let data = {
            clinicians,
            professions,
            eventTypes,
            calendarConfig,
            groupId: this.props.selectedGroup,
            clinicId: this.props.selectedClinic,
            exportType: type,
            lang: this.props.lang,
        }
        this.setState({ loadingExport: true }, () => {

            fetch(API_ENDPOINT + `/data/calendar/occupancy/fetch`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                if (result?.success && result?.file && type === 'excel') {
                    window.location.href = API_ENDPOINT + `${result.file}`;
                    this.setState({ loadingExport: false, exportModal: false })
                } else if (result?.pdf && type === 'pdf') {
                    setTimeout(() => {
                        let path = result.pdf;
                        let name = result?.pdfName ?? 'occupancy.pdf';
                        let pdfUrl = API_ENDPOINT + path;
                        var link = document.createElement("a");
                        link.download = name ? name : 'test';
                        link.target = "_blank";

                        link.href = pdfUrl;
                        document.body.appendChild(link);
                        link.click();

                        this.setState({ loadingExport: false, exportModal: false })
                    }, 1000);
                } else {
                    this.setState({ loadingExport: false, exportModal: false })
                }

            }).catch(err => {
                console.log(err);
                this.setState({ loadingExport: false })
            })
        })

    }

    render() {
        if (typeof window === 'undefined') {
            return;
        }
        // if (window.innerWidth < 768) {
        //     return (
        //         <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
        //             <p style={{ textAlign: 'center', fontWeight: 600, marginTop: 50 }}>
        //                 {"Please use a desktop device to access this page.".translate(this.props.lang)}
        //             </p>
        //         </div>
        //     )
        // }
        const summary = this.state.summary;

        return (
            <div className={this.props.autoHideSidebar ? "dashboard dashboard-auto-hide" : "dashboard"}>
                <Container fluid>
                    <Row>
                        <Col lg='12'>
                            <div className='panel'>
                                <div className="component-header-wrap">
                                    <h5 className="component-header">
                                        {this.props.linksMeta && this.props.linksMeta[this.props[0].location.pathname] ? this.props.linksMeta[this.props[0].location.pathname][this.props.lang] : ''}
                                    </h5>
                                    <div className="component-header-actions">
                                        <Button
                                            color="primary"
                                            disabled={!this.state.availabilityData}
                                            onClick={() => {
                                                this.setState({ exportModal: !this.state.exportModal })
                                            }}>
                                            {'Export'.translate(this.props.lang)}
                                        </Button>
                                    </div>

                                </div>

                                <div className='multi-calendar-wrap occupancy-calendar-wrap'>

                                    {
                                        this.state.loading || this.state.loadingExport ?
                                            <div className="export-loader-wrap">
                                                <div className="loader-wrap">
                                                    <Player
                                                        autoplay={true}
                                                        loop={true}
                                                        renderer={'svg'}
                                                        src="/lf30_editor_l5cxzdyf.json"
                                                        style={{ height: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px", width: typeof window != 'undefined' && window.innerWidth < 768 ? "128px" : "256px" }}
                                                    ></Player>

                                                </div>
                                            </div>
                                            :
                                            null
                                    }

                                    <OccupancyCalendar
                                        {...this.props}
                                        data={this.state.availabilityData}
                                        summary={summary}
                                        onChangeDate={(date, view, viewMode) => {
                                            this.setState({
                                                calendarConfig: {
                                                    date,
                                                    view,
                                                    viewMode
                                                }
                                            }, () => {
                                                this.fetchItems();
                                            })
                                        }}
                                        customFilters={[
                                            <CustomFilterCalendar
                                                {...this.props}
                                                occupancy={true}
                                                onChange={(data) => {
                                                    let filter = {
                                                        clinicians: [...data.clinicians],
                                                        professions: [...data.professions],
                                                        eventTypes: [...data.eventTypes]
                                                    }
                                                    let changesExists = false;
                                                    if (JSON.stringify(filter) !== JSON.stringify(this.state.filter)) {
                                                        changesExists = true;
                                                    } else if (filter.clinicians.length !== this.state.filter.clinicians.length) {
                                                        changesExists = true;
                                                    } else if (filter.professions.length !== this.state.filter.professions.length) {
                                                        changesExists = true;
                                                    } else if (filter.eventTypes.length !== this.state.filter.eventTypes.length) {
                                                        changesExists = true;
                                                    }

                                                    if (changesExists) {
                                                        this.setState({
                                                            filter
                                                        }, () => {
                                                            this.fetchItems();
                                                        })
                                                    }

                                                }}
                                            />
                                        ]}
                                        legendData={this.state.legendData}
                                    />

                                </div>

                            </div>

                        </Col>
                    </Row>
                </Container>
                {
                    this.state.exportModal ?
                        <Modal
                            isOpen={this.state.exportModal}
                            toggle={() => this.setState({ exportModal: null })}
                            className='custom-calendar-event-preview-modal'
                            centered
                        >
                            <ModalBody>

                            </ModalBody>
                            <ModalFooter className='modal-footer-buttons-wrap' style={{ justifyContent: 'center' }}>
                                <Button
                                    color="primary"
                                    style={{ minWidth: 100 }}
                                    disabled={this.state.loadingExport}
                                    onClick={() => {
                                        this.exportData('excel');
                                    }}
                                >
                                    {'Excel'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color="primary"
                                    style={{ minWidth: 100 }}
                                    disabled={this.state.loadingExport}
                                    onClick={() => {
                                        this.exportData('pdf');
                                    }}
                                >
                                    {'PDF'.translate(this.props.lang)}
                                </Button>
                                <Button
                                    color="primary"
                                    disabled={this.state.loadingExport}
                                    style={{ minWidth: 100 }}
                                    onClick={() => this.setState({ exportModal: null })}
                                >
                                    {'Close'.translate(this.props.lang)}
                                </Button>
                            </ModalFooter>
                        </Modal>
                        :
                        null
                }


                {
                    this.state.error ?
                        <ErrorModal
                            lang={this.props.lang}
                            isOpen={this.state.error}
                            toggle={() => this.setState({ error: null })}
                            closeButtonText={'Cancel'.translate(this.props.lang)}
                        >
                            {this.state.error}
                        </ErrorModal>
                        :
                        null
                }

            </div>


        )
    }
}

export default Page(Occupancy);